export default "__VITE_ASSET__r4p5RUFV__"